(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('ReasonWriteOffController', ReasonWriteOffController);

    ReasonWriteOffController.$inject = ['$scope', '$state', 'DataUtils', 'ReasonWriteOff','NgTableParams'];

    function ReasonWriteOffController ($scope, $state, DataUtils, ReasonWriteOff,NgTableParams) {
        var vm = this;
//        vm.reasonWriteOff = [{code:'R01',description:'Phát sử dụng thông thường', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
//                              {code:'R02',description:'Phát sử dụng đặt biệt', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
//                              {code:'R03',description:'Hủy', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
//                              {code:'R04',description:'Mất', note:'nhập lý do vào ô Ghi chú khác',status:'1'},
//                              {code:'R05',description:'Tra OP Admin', note:'nhập lý do vào ô Ghi chú khác',status:'1'}];
        vm.reasonWriteOff = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	ReasonWriteOff.query(function(result) {
                vm.reasonWriteOff = result;
                if(vm.reasonWriteOff !=null && vm.reasonWriteOff.length > 0){
                	var i;
                	for( i = 0; i < vm.reasonWriteOff.length; i++){
                		if(vm.reasonWriteOff[i].status == 1){
                			vm.reasonWriteOff[i].statusName = true;
                		}else{
                			vm.reasonWriteOff[i].statusName = false;
                		}
                		
                		if(vm.reasonWriteOff[i].typeReason == 'NORMAL'){
                			vm.reasonWriteOff[i].typeReasonName = 'Bình Thường';
                		}else if(vm.reasonWriteOff[i].typeReason == 'RETURN'){
                			vm.reasonWriteOff[i].typeReasonName = 'Hoàn Trả';
                		}else if(vm.reasonWriteOff[i].typeReason == 'LOST'){
                			vm.reasonWriteOff[i].typeReasonName = 'Mất';
                		}else{
                			vm.reasonWriteOff[i].typeReasonName = '';
                		}
                		if(vm.reasonWriteOff[i].typeStock == '1'){
                			vm.reasonWriteOff[i].typeStockName = 'Kho chính';
                		}else if(vm.reasonWriteOff[i].typeStock == '2'){
                			vm.reasonWriteOff[i].typeStockName = 'Kho chi nhánh';
                		}else if(vm.reasonWriteOff[i].typeStock == '3'){
                			vm.reasonWriteOff[i].typeStockName = 'Tất cả';
                		}else{
                			vm.reasonWriteOff[i].typeReasonName = '';
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.reasonWriteOff
    				});
                }
            });
        }
    }
})();
